import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SidebarNav from '@/components/SidebarNav';
import Avatar from '@/components/Avatar';
import SidebarSearch from '@/components/SidebarSearch';
import SidebarAccountSwitcher from '@/components/SidebarAccountSwitcher';
import { I } from '@/lib/icons';
import { SECTIONS } from '@/lib/sections';
import { useWorkspace, useClients, useInvoices, useExpenses, useDocuments } from '@/hooks/useData';
import { FEATURES } from '@/lib/featureFlags';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { workspace } = useWorkspace();
  const { invoices } = useInvoices(workspace?.id);
  const { expenses } = useExpenses(workspace?.id);
  const { clients } = useClients(workspace?.id);
  // Pass null when the documents flag is off — hook short-circuits, no Supabase query.
  const { documents } = useDocuments(FEATURES.documents ? workspace?.id : null);

  const sectionItems = SECTIONS.map(s => {
    let count = null;
    if (s.id === 'faktury') count = invoices.length;
    else if (s.id === 'vydavky') count = expenses.length;
    else if (s.id === 'dokumenty') count = documents.length;
    else if (s.id === 'klienti') count = clients.length;
    return { ...s, count };
  });

  const pinned = clients.filter(c => c.is_pinned);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const pinnedSlot = pinned.length > 0 ? (
    <>
      <div style={{
        fontSize: 11, fontWeight: 600, color: 'var(--text-muted)',
        padding: '16px 10px 6px', letterSpacing: '0.02em',
        display: 'flex', alignItems: 'center', gap: 6,
      }}>
        <I.star /> Hviezdny klienti
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {pinned.map(c => (
          <button key={c.id} onClick={() => navigate(`/klienti/${c.id}`)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '5px 10px', border: 'none', background: 'transparent',
              borderRadius: 'var(--r-sm)', cursor: 'pointer', textAlign: 'left',
              fontFamily: 'inherit',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <Avatar name={c.name} size={20} />
            <span style={{
              fontSize: 12.5, color: 'var(--text-primary)', flex: 1,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{c.name}</span>
            <span style={{ color: 'var(--sec-yellow)', display: 'inline-flex', flexShrink: 0 }}>
              <I.star />
            </span>
          </button>
        ))}
      </div>
    </>
  ) : null;

  return (
    <SidebarNav
      sections={sectionItems}
      isActive={isActive}
      onNavigate={navigate}
      searchSlot={<SidebarSearch />}
      pinnedSlot={pinnedSlot}
      // Wallet pocket account switcher — replaces AccountPanel.
      // Žiadny border-top — karty visia priamo, separator je vizuálne v shadowe karty.
      accountSlot={<SidebarAccountSwitcher />}
    />
  );
}
